import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import Select from 'react-select';
import ChangeForm from './InstallerUpdateForms';

import { getZoneList } from '../../../../../../jsx/reducers/paygAdmin/zones';
import { Button } from '@material-ui/core';
import { TabletMacRounded,RefreshRounded } from '@material-ui/icons';
import CardButton from '../../../commonModules/interface/CardButton';
import PopUp from '../../../commonModules/interface/PopUp';


const listStatus = [
    {label: "Actif ", value: "active"},
    {label: "Bloqué", value: "blocked"},
    {label: "Indisponible", value: "unavailable"},
]

class ChangeStatusForm extends Component {
    render () {
        return (
            <PopUp
                maxWidth="sm"
                title="Changer le statut"
                close={this.props.close}
                submitAction={this.props.handleSubmit}
            >
                <InputSelect
                    options={listStatus}
                    name="newStatus"
                    value={this.props.newStatusDisplay}
                    placeholder="Choisissez un Statut"
                    onChange={ this.props.handleSelect }
                    // selectedValue={this.state.status}
                />
                {/* <Select
                    options={listStatus}
                    className="form-control"
                    name="newStatus"
                    value={this.props.statusDisplay}
                    placeholder="Choisissez un Statut"
                    onChange={ this.props.handleSelect }
                    style={{border: '0'}}
                    // selectedValue={this.state.status}
                /> */}
            </PopUp>
        )
    } 
}

class AgentOptions extends Component {
    state = { 
        form: "",
        newAgentID: "",
        newStatus: "",
        statusDisplay: {value:"", label:""},
        newZone: "",
        zoneDisplay: {value:"", label:""},
        listZone : [
            {label: "Zone 1 ", value: "zone_1"},
        ]
    }
    handleChange = (e) => {
        const { name, value } = e.target;  
        this.setState({
            [name]: value
        })
    }
    componentDidMount = () => {
        if (this.props.ZONE === ""){
            this.props.getZones()
        }
    }
    // handleSelect = (option) => {
        
    //     this.setState({
    //         [name]: option,
    //         [`${name}Display`]: option.value
    //     })
    // }

    handleSubmit = () => {
        const { form } = this.state;
        let url = ""
        let data = {}
        let valid = false
        data.agentID = this.props.userID
        
        if( this.state.newStatus && form === "status" ){
            url = "/agent/update/status"
            data.newStatus = this.state.newStatus
            valid = true
        } else if( this.state.newZone && form === "zone" ){
            url = "/agent/zone/attribute"
            data.newZone = this.state.newZone
            valid = true
        } else if( this.state.newAgentID && form === "newID" ){
            url = "/agent/update/ID"
            data.newID = this.state.newAgentID
            valid = true
        }
        console.log('====================================');
        console.log("AGENT OPTIONS Send to ", {valid, url, data});
        console.log('====================================');
        this.handleAct(url, data)
    }
    handleAct = async (url,data) => {
        //Change FORMS
        console.log("Update Info for ",url, " with ",data)
        try {
            const response = await fetch(url, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body:JSON.stringify(data),
              credentials: 'same-origin'
            });
            const resp = await response.json();
            console.log("[INFO], Response from update: , ");            
            console.log(resp);
            if (resp.content === "OK") {
                this.props.close()
                return;
            }
            console.log("[ERROR], response ", resp)

          } catch (err) {
            console.log("[ERROR], getting response", err)
          }
    }
    render() {
        const { ZONE } = this.props;
        this.state.listZone = ZONE;
        const { form } = this.state;
        console.log('====================================');
        console.log("[STATE] AgentOptions render", this.state);
        console.log('====================================');
        return (
            <div>
                {form === "status" &&
                    // <div>
                    //     <h4>Changer le Statut</h4>
                        <ChangeStatusForm 
                            {...this.state} 
                            handleChange={this.handleChange} 
                            handleSelect={
                                (option) => this.setState({ statusDisplay: option, newStatus: option.value})
                            } 
                            handleSubmit={this.handleSubmit}
                            close={()=> this.setState({form : ""})}
                        />
                    //     <div>
                    //         <Button 
                    //             variant="contained"
                    //             color="secondary"
                    //             className="btn btn-success"
                    //             onClick={ this.handleSubmit }
                    //         >
                    //             Valider
                    //         </Button>
                    //         {/* <br/> */}
                    //         <Button 
                    //             type="button" 
                    //             color="secondary"
                    //             className="btn btn-default" 
                    //             onClick={()=> this.setState({form : ""})}
                    //         > 
                    //             Annuler
                    //         </Button>
                    //     </div>
                    // </div>
                }
                {form === "updateFORMS" &&
                    <ChangeForm 
                        {...this.state} 
                        userID={this.props.userID} 
                        cancel={() => this.setState({form : ""}) }
                    />
                }

                <CardButton
                    action={()=> this.setState({form : "status"})}
                    title="Modifier le Statut"
                    icon={<RefreshRounded color="primary" />}
                />                    
                <CardButton 
                    action={()=> this.setState({form : "updateFORMS"})}
                    title="Changer Questionnaire" 
                    icon={<TabletMacRounded color="secondary" />}
                /> 
            </div>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        ZONE: state.zones
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        getZones: getZoneList,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(AgentOptions)
